var _defs, _path, _path2, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f58220;\n      }\n\n      .st1 {\n        fill: #ef3e33;\n      }\n\n      .st2 {\n        fill: #5c3896;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.1,177.2c-33.5,17.4-74.8,4.3-92.2-29.2-17.4-33.5-4.3-74.8,29.2-92.2,7.2-3.7,14.8-6.1,22.4-7.1-2.6-.3-5.3-.4-7.9-.4-42.8,0-77.5,34.7-77.5,77.6s34.7,77.6,77.5,77.6,56.5-17.4,69.3-42.8c-5.6,6.6-12.6,12.3-20.8,16.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.4,44.5c34.7-15,74.9.9,90,35.5,15,34.7-.9,74.9-35.5,90-7.5,3.2-15.2,5-22.8,5.5,2.6.4,5.2.8,7.9,1,42.7,3,79.7-29.3,82.7-72,3-42.7-29.2-79.8-71.9-82.7-30.2-2.1-57.6,13.4-72,37.9,6.1-6.2,13.4-11.4,21.9-15.1Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "118.1 52.9 94.9 105.5 109.1 110.5 100.5 167.5 124.1 110.7 109.7 106.3 118.1 52.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0f45077fd13154e43ec33721a8c56c69.svg";
export { ForwardRef as ReactComponent };